import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './AuthContext.jsx';
import AppRoutes from './Routes.jsx';
import queryClient from './queryClient.js';

import '@/styles/styles.css';
import '@/styles/tokens.css';
import '@/styles/atoms.css';
import '@/styles/detail.css';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
